import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="text-center mb-8 md:mb-10">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          内容分类导航
        </h2>
        <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
          按分类浏览您感兴趣的内容，快速找到所需资讯
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6 hover:border-primary-200 transition-all"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors mb-4">
              <i className={`${cat.icon} text-xl`}></i>
            </div>
            <h3 className="font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
              {cat.name}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-3">{cat.description}</p>
            <div className="flex items-center justify-between">
              <span className="text-xs text-foreground-500">{cat.articleCount} 篇文章</span>
              <span className="text-xs text-primary-600 font-medium flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                浏览 <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}